import { create } from 'zustand'

const getInitialInterval = (): number => {
  const stored = sessionStorage.getItem('realityCheckIntervalMinutes')
  return stored ? parseInt(stored, 10) * 60 * 1000 : 0
}

interface RealityCheckState {
  interval: number
  startTime: number
  intervalStartTime: number
  isShowPopup: boolean
  popupCount: number
  showPopup: () => void
  hidePopup: () => void
  resetTimer: () => void
}

export const useRealityCheckStore = create<RealityCheckState>(set => ({
  interval: getInitialInterval(),
  startTime: Date.now(),
  intervalStartTime: Date.now(),
  isShowPopup: false,
  popupCount: 0,
  showPopup: () => set(state => ({ isShowPopup: true, popupCount: state.popupCount + 1 })),
  hidePopup: () => set({ isShowPopup: false }),
  resetTimer: () => set({ intervalStartTime: Date.now() }),
}))
